import { atom } from 'recoil';

// NOTE: 캠페인 상태 변경하는 react-query mutate의 loading 확인 용도의 글로벌 상태 관리 atom
const fetchingCampaignLoading = atom({
  key: 'fetchingCampaignLoading',
  default: false,
});

export default fetchingCampaignLoading;
